import React, { useContext } from "react";
import { Stack } from "@fluentui/react";
import { Form, Input, Button, notification } from "antd";
import { LockOutlined, CheckOutlined, MailOutlined } from "@ant-design/icons";
import { Formik } from "formik";
import { LoginValidationSchema } from "../../../Utility/Validations/HomeValidations";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import HomeStore from "../store/homestore";
import { setDefaultMenuOpenkey } from "../../../Utility/modules/helpers";
const initFormData = {
  username: "",
  password: "",
};
export const SignInForm = observer((props) => {
  const navigate = useNavigate();
  const homeStore = useContext(HomeStore);
  return (
    <Formik
      initialValues={initFormData}
      validationSchema={LoginValidationSchema}
      validateOnBlur={true}
      validateOnChange={false}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          homeStore.loginInProgress = true;
          const retVal = await homeStore.login({ ...values });
          if (retVal.isWelcomed && retVal.lastVisitedUrl !== null) {
            setDefaultMenuOpenkey(retVal.menuId);
            navigate(retVal.lastVisitedUrl);
          } else {
            navigate("main/userprofile/settings");
          }

          homeStore.loginInProgress = false;
        } catch (error) {
          if (!error.response) {
            notification.error({
              key: "error",
              message: "SPARS Feedback",
              description:
                "SPARS Backend Server is not reachable, please contact SPARS support",
            });
            homeStore.loginInProgress = false;
          }

          notification.error({
            message: "SPARS Feedback",
            description: error?.response?.body?.message,
          });
          homeStore.loginInProgress = false;
        } finally {
          homeStore.loginInProgress = false;
          //setSubmitting(true);
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => (
        <Form onFinish={handleSubmit}>
          <Stack tokens={{ childrenGap: 10 }}>
            <Form.Item help={touched.username && errors.username}>
              <Input
                placeholder="Work Email"
                prefix={<MailOutlined style={{ color: "#667EEA" }} />}
                name="username"
                value={values?.username}
                onChange={handleChange}
                allowClear
              />
            </Form.Item>

            <Form.Item
              name="password"
              help={touched.password && errors.password}
            >
              <Input.Password
                placeholder="Password"
                prefix={<LockOutlined style={{ color: "#667EEA" }} />}
                name="password"
                value={values?.password}
                onChange={handleChange}
                allowClear
              />
            </Form.Item>

            <Form.Item style={{ textAlign: "right" }}>
              <Button
                type="primary"
                htmlType="submit"
                icon={<CheckOutlined />}
                loading={homeStore.loginInProgress}
              >
                Login
              </Button>
            </Form.Item>
          </Stack>
        </Form>
      )}
    </Formik>
  );
});

